import * as yup from "yup";
import {
  stringNullable,
  stringRequired,
  stringNullableRequired,
} from "yup/defaultValudations";

export const schema = yup.object().shape({
  price: stringRequired(),
  validUntil: stringNullableRequired(),
  message: stringNullable(),
  UserAssigneeId: stringNullable(),
});
